import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";

import Badge from "@mui/material/Badge";

import NotificationsIcon from "@mui/icons-material/Notifications";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";

const NotificationCountBadge = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [notificationCount, setNotificationCount] = useState([]);
  const [showSidebar, setShowSidebar] = useState(false);

  /*   useEffect(() => {
    loadData();
  }, []); */

  const linkClick = (toUrl) => {
    navigate(toUrl);
  };
  /*   const loadData = () => {
    const form = new FormData();
    form.append("type", "staff");
    form.append("uuid", context.user.uuid);
    form.append("course", context.user.emp_academic_department);
    axios.post(ServiceUrl.MOB.MY_NOTIFICATION_COUNT, form).then((res) => {
      if (res["data"].status == "1") {
        if (parseInt(res["data"].data.history_count) > 0) {
          setNotificationCount(
            parseInt(res["data"].data.count) -
              parseInt(res["data"].data.history_count)
          );
        } else {
          setNotificationCount(parseInt(res["data"].data.count));
        }
      } else {
      }
      //  setLoader(false);
    });
  }; */

  return (
    <a onClick={(e) => linkClick("/staff/app/notification")}>
      <Badge
        sx={{
          "& .MuiBadge-badge": {
            backgroundColor: notificationCount > 0 ? "white" : "transparent",
            color: notificationCount > 0 ? "black" : "transparent",
          },
        }}
        badgeContent={notificationCount > 0 ? notificationCount : null}
      >
        <NotificationsIcon style={{ color: "#fff" }} />
      </Badge>
    </a>
  );
};
export default NotificationCountBadge;
